export type ShareChannelId = 'telegram' | 'whatsapp' | 'vk' | 'max' | 'email';

type ShareContent = {
  /** Полный текст приглашения — уходит в тело сообщения. */
  text: string;
  /** Ссылка на встречу отдельным параметром: Telegram и VK строят по ней превью. */
  link: string;
};

const EMAIL_SUBJECT = 'Приглашение на встречу в ZiNGiZi';

/** Адрес share-интента канала — обычная https-ссылка, открывается через <a target="_blank">. */
export function buildShareHref(channel: ShareChannelId, { text, link }: ShareContent): string {
  const encodedText = encodeURIComponent(text);
  const encodedLink = encodeURIComponent(link);

  switch (channel) {
    case 'telegram':
      return `https://t.me/share/url?url=${encodedLink}&text=${encodedText}`;
    case 'whatsapp':
      return `https://wa.me/?text=${encodedText}`;
    // share.php — единственный web-интент VK; в открывшемся диалоге пользователь
    // выбирает между стеной и отправкой сообщения в чат.
    case 'vk':
      return `https://vk.com/share.php?url=${encodedLink}&comment=${encodedText}&noparse=true`;
    case 'email':
      return `mailto:?subject=${encodeURIComponent(EMAIL_SUBJECT)}&body=${encodedText}`;
    // Универсальный диплинк MAX: работает на iOS, Android и в вебе, отдельного
    // параметра под ссылку нет — text уже содержит её последней строкой.
    case 'max':
      return `https://max.ru/:share?text=${encodedText}`;
  }
}
